module.exports = __webpack_public_path__ + "img/mt14.81b235ef.jpg";